import React from 'react';
import { ReactComponent as AssessmentC } from '../../graphics/svgs/assessment-c.svg';
import { ReactComponent as MDReviewC } from '../../graphics/svgs/mdreview-c.svg';
import { ReactComponent as CompoundingC } from '../../graphics/svgs/compounding-c.svg';
import { ReactComponent as ShippedC } from '../../graphics/svgs/shipped-c.svg';
import { ReactComponent as DeliveredC } from '../../graphics/svgs/delivered-c.svg';

import { ReactComponent as AssessmentWarning } from '../../graphics/svgs/assessment-warning.svg';

import { ReactComponent as AssessmentNC } from '../../graphics/svgs/assessment-nc.svg';
import { ReactComponent as MDReviewNC } from '../../graphics/svgs/mdreview-nc.svg';
import { ReactComponent as CompoundingNC } from '../../graphics/svgs/compounding-nc.svg';
import { ReactComponent as ShippedNC } from '../../graphics/svgs/shipped-nc.svg';
import { ReactComponent as DeliveredNC } from '../../graphics/svgs/delivered-nc.svg';


//// the above images that are NC or warning are part of the stages. If a step is not in current stage or completed it will show the nc svg version


const TreatmentJourney = () => {
  const steps = [
    {
      title: "Telehealth assessment",
      description: "Completed on Dec 10, 2025",
      icon: <AssessmentC width={37} height={37} />
    },
    {
      title: "Under Physician review",
      description: "Dr. Shareef is currently reviewing your intake",
      icon: <MDReviewC width={37} height={37} />
    },
    {
      title: "Custom cream is being compounded",
      description: "Completed on Dec 10, 2025",
      icon: <CompoundingC width={37} height={37} />   
    },
    {
      title: "Shipped",
      description: "Completed on Dec 10, 2025",
      icon: <ShippedC width={37} height={37} />
    },
    {
      title: "Start Treatment",
      description: "Completed on Dec 10, 2025",
      icon: <DeliveredC width={37} height={37} /> 
    }
  ];

  return (
    <div className="bg-white p-6 w-full" style={{ border: '1px solid var(--neutral-300)', borderRadius: '32px' }}>
      <div className="flex justify-between items-center mb-2">
        <h3 className="h4 text-[var(--theme-text-primary)] mb-0" style={{ fontWeight: 600 }}>
          Treatment Journey
        </h3>
      </div>
      
      <div className="flex flex-col gap-5">
        {steps.map((step, index) => (
          <div key={index} className="flex items-start gap-4">
            {/* Icon container */}
            <div className="flex-shrink-0 pt-1">
               {step.icon}
            </div>
            
            <div className="flex flex-col">
              <span className="font-semibold text-[var(--theme-text-primary)] leading-tight mb-1" style={{ fontFamily: 'var(--font-body1-fontFamily)', fontSize: '16px' }}>
                {step.title}
              </span>
              <h6 className="h6 text-theme-text-secondary mb-0">
                {step.description}
              </h6>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TreatmentJourney;
